// IT
export const reservasSmallHc = {
  createAlerta: {
    title: `Crea nuovo promemoria`,
    infoHeading: `Informazioni del promemoria`,
    selectPropertyLabel: `Seleziona la struttura a cui assegnare il promemoria`,
    dayLabel: `Seleziona un giorno della settimana:`,
    dayMonday: `Lunedì`,
    dayTuesday: `Martedì`,
    dayWednesday: `Mercoledì`,
    dayThursday: `Giovedì`,
    dayFriday: `Venerdì`,
    daySaturday: `Sabato`,
    daySunday: `Domenica`,
    selectTimeLabel: `Seleziona l'ora`,
    sendAtLabel: `Sarà inviato alle:`,
    minutesLabel: `Con {minutes} minuti:`,
    previewPre: `L'avviso sarà inviato agli ospiti nei giorni`,
    previewMid: `alle`,
    descriptionLabel: `Descrizione dell'avviso`,
    descriptionPlaceholder: `Inserisci una descrizione per l'avviso`,
    messageTypeLabel: `Seleziona il tipo di messaggio da inviare.`,
    messageTypeSimple: `Messaggio semplice`,
    messageTypeLink: `Messaggio con link alla fine`,
    messageTypeFile: `Messaggio con file allegato alla fine`,
    linkFieldLabel: `Inserisci il link da inviare con il promemoria`,
    fileFieldLabel: `Carica il file da inviare con il promemoria`,
    fileNameLabel: `Nome del file`,
    cancel: `Annulla`,
    save: `Salva promemoria`,
    errorDayRequired: `Il giorno è obbligatorio`,
    errorTimeRequired: `L'ora è obbligatoria`,
    errorSelectMinutes: `Seleziona i minuti`,
    errorDescriptionRequired: `La descrizione è obbligatoria`,
    errorAttachmentRequired: `L'allegato è obbligatorio oppure seleziona il tipo di messaggio semplice`,
  },
  reservationData: {
    statusConfirmed: `Confermato`,
    statusRejected: `Rifiutato`,
    statusTentative: `Soggetto a disponibilità`,
    statusWithinCheckin: `Entro l'orario di check-in`,
    statusFree: `Senza costo`,
    modalTitleApprove: `Approvare la richiesta?`,
    modalTitleApproveTime: `Approvare a un altro orario?`,
    modalTitlePrioritize: `Dare priorità a questo check-in?`,
    modalTitleReject: `Rifiutare la richiesta?`,
    modalTitleDefault: `Confermare?`,
    modalTextApprove: `Stai per approvare il check-in anticipato di`,
    modalTextApproveTime: `Confermerai il check-in all'orario che indichi per`,
    modalTextPrioritize: "Gli diremo che farete il possibile per averlo pronto a quell'ora, anche se dipende dalla partenza precedente e dalle pulizie. Verrà inviato a",
    modalTextReject: `Stai per rifiutare il check-in anticipato di`,
    modalTextDefault: `Conferma per`,
    modalCtaApprove: `Sì, approva`,
    modalCtaApproveTime: `Conferma orario`,
    modalCtaPrioritize: `Sì, informa`,
    modalCtaReject: `Sì, rifiuta`,
    modalCtaDefault: `Conferma`,
    kpiRoom: `Camera`,
    kpiLodging: `Alloggio`,
    guestsCount: `ospite | ospiti`,
    adultsCount: `adulto | adulti`,
    childrenCount: `bambino | bambini`,
    infantsCount: `neonato | neonati`,
    roomsCountValue: `{count} camere`,
    holderRole: `Titolare della prenotazione`,
    noEmail: `Nessuna email assegnata`,
    writeWhatsapp: `Scrivi su WhatsApp`,
    noPhoneTitle: `Senza telefono non è possibile inviare tramite WhatsApp. Puoi aggiungerlo in «Modifica prenotazione».`,
    noPhone: `Nessun telefono assegnato`,
    kpiCheckin: `Check-in`,
    kpiCheckout: `Check-out`,
    earlyRequested: `Check-in anticipato richiesto`,
    arrivalRequested: `Orario di arrivo richiesto`,
    arrivesAt: `Arriva alle {time}`,
    actionApprove: `Approva`,
    actionOtherTime: `Altro orario`,
    actionPrioritize: `Dai priorità`,
    actionReject: `Rifiuta`,
    awaitingPayment: "In attesa del pagamento dell'ospite",
    cannotUndo: `Questa azione non può essere annullata.`,
    checkinTimeLabel: `Orario di check-in`,
    earlyPrioritisedTitle: "Check-in anticipato prioritario",
    earlyApprovedTitle: "Check-in anticipato approvato",
    earlyRejectedTitle: "Check-in anticipato rifiutato",
    earlyLineApproved: "Arriverà alle {time}",
    earlyLineApprovedOther: "Arriverà alle {time} · aveva chiesto le {original}",
    earlyLineRejected: "Aveva chiesto le {time} · entrerà all'orario abituale",
    earlyLineRejectedStd: "Aveva chiesto le {time} · entrerà all'orario abituale ({std})",
    earlyLinePrioritised: "Vuole arrivare alle {time} · gli abbiamo detto che faremo il possibile",
    extRequestedTitle: "Estensione del soggiorno richiesta",
    extAwaitingTitle: "Estensione del soggiorno in attesa di pagamento",
    extConfirmedTitle: "Estensione del soggiorno confermata",
    extNights: "Notti aggiunte: {nights} · nuova partenza il {date}",
    extAtProperty: "{amount} da pagare in struttura",
    extPendingHost: "in attesa della tua approvazione",
    lateRequestedTitle: "Check-out posticipato richiesto",
    lateAwaitingTitle: "Check-out posticipato in attesa di pagamento",
    lateConfirmedTitle: "Check-out posticipato confermato",
    lateRejectedTitle: "Check-out posticipato rifiutato",
    lateLeavesAt: "Parte alle {time}",
    lateWantsToLeave: "Vuole partire alle {time}",
    lateInsteadOf: "(invece che alle {std})",
    latePaid: "Pagato: {amount}",
    lateCourtesy: "Ora di cortesia, senza costi",
    lateFree: "Senza costi",
    lateCash: "{amount} in contanti alla partenza",
    lateUnpaid: "{amount}, non ancora pagato",
    lateLineRejected: "Ha chiesto di partire alle {time} · parte all'orario abituale",
    lateLineRejectedStd: "Ha chiesto di partire alle {time} · parte all'orario abituale ({std})",
    requestedTimeHint: "L'ospite ha chiesto le {time}",
    toastApproved: "Check-in anticipato approvato",
    toastApprovedTime: "Nuovo orario di ingresso approvato",
    toastPrioritised: "Check-in anticipato prioritario",
    toastRejected: "Check-in anticipato rifiutato",
    toastNotified: "Abbiamo già scritto all'ospite.",
    toastNotNotified: "Non è stato possibile avvisare l'ospite: scrivigli tu.",
    toastAlreadyDecided: "Questa richiesta era già stata decisa: l'ospite non è stato ricontattato.",
    toastError: "Impossibile salvare la decisione. Riprova.",
    toastAlreadyPaid: "Era già pagata: non è stato addebitato di nuovo.",
    toastRefundMaybeDue: "Ha pagato per entrare prima e ora entra all'orario normale: se è il caso, rimborsalo.",
    actionReadyNow: "Può già entrare",
    actionNotPossible: "Non sarà possibile",
    toastPaymentLinkFailed: "Non è stato possibile creare il link di pagamento: incassalo in un altro modo.",
    arrivalApprovedTitle: "Orario di arrivo confermato",
    arrivalRejectedTitle: "Orario di arrivo rifiutato",
    arrivalLineRejected: "Voleva arrivare alle {time}",
    modalTextApproveArrival: "Stai per confermare l'orario di arrivo di",
    modalTextRejectArrival: "Stai per rifiutare l'orario di arrivo di",
    toastArrivalApproved: "Orario di arrivo confermato",
    toastArrivalRejected: "Orario di arrivo rifiutato",
    cancel: `Annulla`,
  },
  minStayModal: {
    summaryNoData: `Nessun dato nell'intervallo selezionato`,
    summaryHintMixed: `Sono stati rilevati diversi soggiorni minimi nell'intervallo. Il campo è impostato su 1 notte per definire il nuovo valore.`,
    summaryHintSingle: `Il campo è stato caricato con il soggiorno minimo attuale dell'intervallo selezionato.`,
    errorMinOne: `Il soggiorno minimo deve essere di almeno 1 notte.`,
    opStartLabel: `Modifica del soggiorno minimo…`,
    successUpdated: `Soggiorno minimo aggiornato correttamente`,
    errorUpdate: `Errore durante l'aggiornamento del soggiorno minimo`,
    errorUnknown: `Errore sconosciuto`,
    title: `Soggiorno minimo`,
    description: `Imposta il soggiorno minimo in notti per l'intervallo di date selezionato.`,
    detectedLabel: `Soggiorni minimi rilevati`,
    minStayLabel: `Soggiorno minimo (notti)`,
    decreaseAria: `Diminuisci il soggiorno minimo`,
    minNightsPlaceholder: `Es: 2`,
    increaseAria: `Aumenta il soggiorno minimo`,
    hint: `Numero minimo di notti che l'ospite deve prenotare.`,
    cancel: `Annulla`,
    save: `Salva`,
  },
  modalCompleteReservation: {
    errorContactRequired: `Per continuare devi compilare uno dei due campi (telefono o email)`,
    successMsg: `Dati della prenotazione completati con successo`,
    successTitle: `Operazione eseguita con successo`,
    title: `Completa prenotazione`,
    bookingDateLabel: `Date della prenotazione`,
    checkin: `Check-in`,
    checkout: `Check-out`,
    phoneRequiredHint: `* Unico campo obbligatorio`,
    emailHint: `*Se indichi l'email il cliente non dovrà inserirla`,
    responsibleLabel: `Inserisci il nome del responsabile`,
    responsiblePlaceholder: `Responsabile della prenotazione`,
    scheduleLabel: `Programma la data di invio del link di check-in.`,
    scheduleAuto: `Invio automatico`,
    schedule24: `24 ore prima del check-in`,
    schedule48: `48 ore prima del check-in`,
    schedule72: `72 ore prima del check-in`,
    scheduleWeek: `Una settimana prima del check-in`,
    cancel: `Annulla`,
    complete: `Completa prenotazione`,
  },
  payData: {
    errorNoPaymentRecord: `Impossibile identificare la registrazione del pagamento.`,
    partialLinkGenerated: `Link di pagamento generato correttamente.`,
    errorGenerateLink: `Impossibile generare il link.`,
    partialRegistered: `Pagamento parziale registrato.`,
    errorSavePartial: `Impossibile salvare il pagamento parziale.`,
    whatsappPartialMsg: `Ciao {name}, ti condividiamo il link per completare il pagamento in sospeso della tua prenotazione: {url}`,
    errorInvoicingNotActive: `La fatturazione elettronica non è attiva nel tuo piano.`,
    fieldBillingProfile: `Profilo di fatturazione`,
    fieldCountry: `Paese`,
    fieldLegalName: `Ragione sociale`,
    fieldTaxId: `NIF/CIF/NIT`,
    fieldAddressStreet: `Indirizzo`,
    fieldAddressCity: `Città`,
    fieldAddressRegion: `Provincia`,
    fieldAddressZip: `Codice postale`,
    fieldEmail: `Email`,
    fieldIsActive: `Attiva profilo`,
    errorBillingIncomplete: `Completa i tuoi dati di fatturazione. Mancano: {fields}`,
    invoiceLinkCopied: `Link di fatturazione copiato.`,
    reservationHasInvoice: `Questa prenotazione ha già una fattura.`,
    errorLoadReceipt: `Impossibile caricare la ricevuta.`,
    errorDownloadReceipt: `Impossibile scaricare la ricevuta.`,
    guestOutOfWindow: `L'ospite è fuori dalla finestra di 24h di WhatsApp.`,
    errorSendReceipt: `Errore durante l'invio della ricevuta.`,
    charge: `Addebito`,
    lodging: `Alloggio`,
    servicesExtras: `Servizi ed extra`,
    free: `Gratis`,
    ivaIncluded: `(IVA {rate}% inclusa)`,
    includedInPrice: `(inclusa nel prezzo)`,
    pendingCharge: `Pagamento in sospeso`,
    viewBreakdown: `Vedi dettaglio prezzi`,
    viewReceipt: `Vedi ricevuta`,
    receiptInfoPre: `Ricevuta informativa. La fattura elettronica viene emessa dalla scheda`,
    chargesTab: `Addebiti`,
    receiptInfoNoInvoice: `Ricevuta informativa disponibile. Per la fatturazione elettronica, configura i tuoi dati di fatturazione.`,
    reservationNumber: `Prenotazione #{code}`,
    currentStatus: `Stato attuale`,
    willChangeTo: `Cambierà in:`,
    saving: `Salvataggio…`,
    breakdownTitle: `Dettaglio prezzi`,
    discounts: `Sconti`,
    taxesAndFees: `Imposte e tasse`,
    ivaIncludedInPrice: `IVA ({rate}%) inclusa nel prezzo: {amount}`,
    includesTaxes: `Include {amount} di imposte incluse nel prezzo`,
    total: `Totale`,
    close: `Chiudi`,
    loadingReceipt: `Caricamento ricevuta…`,
    stayReceipt: `Ricevuta del soggiorno · {date}`,
    downloadPdf: `Scarica PDF`,
    sending: `Invio…`,
    sent: `Inviato!`,
    outOfWindow: `Fuori dalla finestra di 24h`,
    sendWhatsapp: `Invia tramite WhatsApp`,
    stayDetail: `Dettagli del soggiorno`,
    ivaIncludedShort: `IVA {rate}% inclusa`,
    discount: `Sconto`,
    nightsCount: `notte | notti`,
    additionalCharges: `Addebiti aggiuntivi`,
    ivaShort: `IVA {rate}%`,
    charged: `Incassato`,
    pending: `In sospeso`,
    receiptGeneratedBy: `Ricevuta generata da`,
    done: `Fatto`,
    registerPartial: `Registra pagamento parziale`,
    reservationTotal: `Totale della prenotazione`,
    amountReceived: `Importo già ricevuto`,
    paid: `Versato`,
    pendingBalance: `Saldo residuo`,
    amountExceedsTotal: `L'importo ricevuto supera il totale. Usa lo stato`,
    paidStatus: `Pagato`,
    internalNote: `Nota interna`,
    optional: `(facoltativo)`,
    notePlaceholder: `Es: Primo pagamento ricevuto tramite bonifico...`,
    autoLinkNote: `Al salvataggio, il link di pagamento verrà aggiornato automaticamente a`,
    cancel: `Annulla`,
    savePartial: `Salva pagamento parziale`,
    roomsCount: `{count} camera | {count} camere`,
    groupNotePre: `Importo della`,
    groupNoteCombined: `prenotazione combinata`,
    groupNoteMid: `dettaglio per camera qui sotto.`,
  },
};
